module.exports = __webpack_public_path__ + "labioplastika_11_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/labioplastika_11_before.jpg
// module id = 1066
// module chunks = 0